import { useContext, useMemo } from 'react';
import { AuthContext } from '../../features/auth/AuthContext';
import type { Permission } from '../types/permissions';

export type PermissionsApi = {
  isAdmin: boolean;
  roleName: string | null;
  hasPermission: (perm: Permission) => boolean;
  hasAnyPermission: (perms: Permission[]) => boolean;
  loaded: boolean;
  currentProfessionalId: string | null;
  isOwnScheduleOnly: boolean;
};

export function usePermissions(): PermissionsApi {
  const ctx = useContext(AuthContext);
  return useMemo<PermissionsApi>(() => {
    const role = ctx?.role ?? null;
    const isAdmin = role?.isAdmin === true;
    const perms = new Set(role?.permissions ?? []);
    const rawProfId = ctx?.userDoc?.professionalId;
    const currentProfessionalId = rawProfId && rawProfId.length > 0 ? rawProfId : null;
    const isOwnScheduleOnly = !isAdmin && currentProfessionalId !== null;
    return {
      isAdmin,
      roleName: role?.name ?? null,
      hasPermission: (perm) => isAdmin || perms.has(perm),
      hasAnyPermission: (list) => isAdmin || list.some((p) => perms.has(p)),
      loaded: ctx?.userDocLoaded ?? false,
      currentProfessionalId,
      isOwnScheduleOnly,
    };
  }, [ctx?.role, ctx?.userDoc, ctx?.userDocLoaded]);
}
